export function timestampToDate(timestamp: number): Date {
  return new Date(timestamp * 1000);
}

/**
 * Return today if date is bigger than today
 */
export function limitMaxForToday(date: Date) {
  const today = new Date(new Date().toDateString());
  if (date > today) {
    return new Date();
  }
  return date;
}
